

export default function getDomain(url) {
    // http://example.com
    // https://example.com

    let start = 0, isHttps = url.substr(4, 1)=== 's';

    if(isHttps) {
        start = 8;
    }
    else {
        start = 7;
    }

    let end = url.indexOf('/', start);

    return url.substr(0, end);

}
